// frontend/src/utils/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://chat.aunimeda.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
  // Add a timeout
  timeout: 10000,
});

// Add a request interceptor to add the auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle network errors
    if (!error.response) {
      console.error('Network error:', error);
      return Promise.reject(new Error('Network error. Please check your connection.'));
    }

    // Handle specific error codes
    switch (error.response.status) {
      case 401:
        // Unauthorized - clear auth data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        delete api.defaults.headers.common['Authorization'];
        window.location.href = '/login';
        break;
      case 404:
        console.error('Resource not found:', error.response);
        break;
      case 500:
        console.error('Server error:', error.response);
        break;
      default:
        console.error('API error:', error.response);
    }

    return Promise.reject(error);
  }
);

export default api; 